<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="top_blurb flex Flexjustify Flexalign">
      <div class="top_blurb_box flex Flexalign FlexBetween">
        <div class="top_blurb_left flex">
          <el-image class="video_img" :src="imgPath(courseDetail.courseCoverImg)"></el-image>
          <div class="top_blurb_text flex flexcolumn FlexBetween">
            <div class="course_title flex Flexalign">{{ courseDetail.courseName }}
              <div class="course_type ml-10" v-if="courseDetail.courseDifficulty">
                {{ getDictObject("difficulty", courseDetail.courseDifficulty) }}
              </div>
            </div>
            <div class="course_organizationName">{{ courseDetail.shopName }}</div>
          </div>
        </div>
        <div class="top_blurb_right flex Flexalign">
          <div class="top_blurb_right_one flex flexcolumn Flexalign cursor_pointer" @click="goMyNote">
            <el-image class="notes_icon" :src="imgPath('notes_icon.png')"></el-image>
            <div>我的笔记</div>
          </div>
          <!-- <div class="top_blurb_right_one flex flexcolumn Flexalign cursor_pointer" @click="goStudyLongTime">
            <el-image class="notes_icon" :src="imgPath('timehours_icon.png')"></el-image>
            <div>学习时长</div>
          </div> -->
          <div class="top_blurb_right_one flex flexcolumn Flexalign cursor_pointer" @click="goEvaluate">
            <el-image class="notes_icon" :src="imgPath('course_evaluate_icon.png')"></el-image>
            <div>评价课程</div>
          </div>
        </div>
      </div>
    </div>
    <div class="blurb_content flex Flexjustify">
      <div class="content_box flex FlexBetween">
        <!-- 左侧菜单 -->
        <leftMenu @getMenu="getMenu" :leftMenu="menuValue"></leftMenu>
        <!-- 简介 -->
        <introduce v-if="menuValue == 1" :courseDetail="courseDetail" @getMenu="getMenu"></introduce>
        <!-- 待办 -->
        <backlog v-if="menuValue == 7 && !showPractice" :backlogStepPass="backlogStep" :courseDetail="courseDetail"
          @getMenu="getMenu" :companionTeacherInfo="companionTeacherInfo"></backlog>
        <!-- 简介右部 -->
        <introduceRight v-if="menuValue == 1 || (menuValue == 7 && !showPractice)" :courseDetail="courseDetail">
        </introduceRight>
        <!-- 学堂 -->
        <school v-if="menuValue == 2 && !showPractice && schoolMenu == 1" :courseDetail="courseDetail"
          :videoUrl="videoUrl" :courseSettingInfo="courseSettingInfo"></school>
        <!-- 习题巩固 -->
        <exerciseConsolidationVue v-if="menuValue == 2 && !showPractice && schoolMenu == 2"
          :courseDetail="courseDetail"></exerciseConsolidationVue>
        <!-- 章节闯关 -->
        <chapterChallenge v-if="menuValue == 2 && !showPractice && schoolMenu == 3" :courseDetail="courseDetail">
        </chapterChallenge>
        <!-- 错题分析 -->
        <wrongQuestionAnalysis v-if="menuValue == 2 && !showPractice && schoolMenu == 4" :courseDetail="courseDetail">
        </wrongQuestionAnalysis>
        <!-- 测评通关 -->
        <assessmentClearance v-if="menuValue == 2 && !showPractice && schoolMenu == 5" :courseDetail="courseDetail">
        </assessmentClearance>
        <!-- 学堂右部 -->
        <schoolRight v-show="menuValue == 2 && !showPractice" :showCourseOutline="true" :courseId="courseId"
          :courseDetail="courseDetail" @getCourseVideoUrl="getCourseVideoUrl" :key="refreshRightey"></schoolRight>
        <!-- 随堂练习 -->
        <div class="test_paper_practice" v-if="menuValue == 2 && showPractice && schoolMenu == 1">
          <testPaper :examInfo="practiceInfo" :hideCountDown="true" @practiceBack="practiceBack"
            @refreshTextExam="refreshTextExam" :schoolMenu="schoolMenu"></testPaper>
        </div>
        <!-- 课堂作业/课后作业 -->
        <div class="test_paper_practice"
          v-if="menuValue == 2 && showPractice && schoolMenu == 2 && !isFinalRecord && !isCustomizeHomework">
          <testPaper :examInfo="practiceInfo" :hideCountDown="false" :testTitle="testTitle" :isHome="true"
            @practiceBack="practiceBack" @refreshTextExam="refreshTextExam" :schoolMenu="schoolMenu" ref="testPaper">
          </testPaper>
        </div>
        <!-- 课后作业 -->
        <div class="test_paper_practice" v-if="menuValue == 7 && showPractice && !isFinalRecord">
          <testPaper :examInfo="practiceInfo" :hideCountDown="true" :testTitle="testTitle" :isHome="true"
            @practiceBack="practiceBack" @refreshTextExam="refreshTextExam" :schoolMenu="schoolMenu"></testPaper>
        </div>
        <!-- 闯关 -->
        <div class="test_paper_practice" v-if="menuValue == 2 && showPractice && schoolMenu == 3">
          <testPaper :examInfo="practiceInfo" :hideCountDown="true" :isChallenge="true" :testType="testType"
            @practiceBack="practiceBack" @refreshTextExam="refreshTextExam" :schoolMenu="schoolMenu">
          </testPaper>
        </div>
        <!-- 错题 -->
        <div class="test_paper_practice" v-if="menuValue == 2 && showPractice && schoolMenu == 4">
          <!-- <wrongQuestionPaper :examInfo="practiceInfo" :hideCountDown="true" @practiceBack="practiceBack"
            @refreshTextExam="refreshTextExam" :title="wrongTitle" :schoolMenu="schoolMenu">
          </wrongQuestionPaper> -->
          <testPaper :examInfo="practiceInfo" :hideCountDown="true" @practiceBack="practiceBack"
            @refreshTextExam="refreshTextExam" :title="wrongTitle" :schoolMenu="schoolMenu"
            :isWrongReubmit="isWrongReubmit">
          </testPaper>
        </div>
        <!-- 通关测评 -->
        <div class="test_paper_practice" v-if="menuValue == 2 && showPractice && schoolMenu == 5 && !isFinalRecord">
          <testPaper :examInfo="practiceInfo" :testTitle="testTitle" :isFinalStep="true" @practiceBack="practiceBack"
            @refreshTextExam="refreshTextExam" :schoolMenu="schoolMenu"></testPaper>
        </div>
        <!-- 通关测评-答题记录 -->
        <div class="test_paper_practice"
          v-if="menuValue == 2 && showPractice && (schoolMenu == 5 || schoolMenu == 2) && isFinalRecord && !isCustomizeHomework">
          <recordTestPaper :examInfo="practiceInfo" :hideCountDown="true" @practiceBack="practiceBack"
            @refreshTextExam="refreshTextExam" :isFinalRecord="isFinalRecord" :schoolMenu="schoolMenu">
          </recordTestPaper>
        </div>
        <!-- 课后作业答题记录（试卷） -->
        <div class="test_paper_practice" v-if="menuValue == 7 && showPractice && isFinalRecord && !isCustomizeHomework">
          <recordTestPaper :examInfo="practiceInfo" :hideCountDown="true" @practiceBack="practiceBack"
            @refreshTextExam="refreshTextExam" :isFinalRecord="isFinalRecord" :schoolMenu="schoolMenu">
          </recordTestPaper>
        </div>
        <!-- 自定义作业答题记录 -->
        <div class="test_paper_practice"
          v-if="(menuValue == 2 || menuValue == 7) && showPractice && (schoolMenu == 5 || schoolMenu == 2 || schoolMenu == 1) && isFinalRecord && isCustomizeHomework">
          <customeHomeworkRecord @practiceBack="practiceBack" ref="customeHomeworkRecord"></customeHomeworkRecord>
        </div>
        <!-- 自定义作业答题右侧点评 -->
        <div
          v-if="(menuValue == 2 || menuValue == 7) && showPractice && (((schoolMenu == 5 || schoolMenu == 2 || schoolMenu == 1) && isFinalRecord)) && isCustomizeHomework">
          <customizeHomeworkSheet ref="customizeHomeworkSheet">
          </customizeHomeworkSheet>
        </div>
        <!-- 课后作业答题卡 -->
        <answerSheet v-if="menuValue == 7 && showPractice && !isCustomizeHomework" @refreshTextExam="refreshTextExam"
          @practiceBack="practiceBack" :showCourseOutline="false" :examType="isFinalRecord ? 'record' : 'practice'"
          :homeworkType="'afterHomework'"></answerSheet>
        <!-- 作业&闯关答题卡 -->
        <answerSheet
          v-if="menuValue == 2 && showPractice && ((schoolMenu == 2 && !isFinalRecord) || schoolMenu == 3 || (schoolMenu == 5 && !isFinalRecord)) && !isCustomizeHomework"
          @refreshTextExam="refreshTextExam" @practiceBack="practiceBack" :showCourseOutline="false"
          :examType="'practice'" :schoolMenu="schoolMenu" :homeworkType="'seatwork'" @backList="backList"></answerSheet>
        <!-- 纠错右侧答题卡功能 -->
        <answerSheet v-if="menuValue == 2 && showPractice && (schoolMenu == 4)" @refreshTextExam="refreshTextExam"
          @practiceBack="practiceBack" :showCourseOutline="false" :examType="'wrongQuestion'" :schoolMenu="schoolMenu"
          :isWrongReubmit="isWrongReubmit" :wrongTitle="wrongTitle">
        </answerSheet>
        <!-- 纠错右侧答题卡功能 -->
        <answerSheet
          v-if="menuValue == 2 && showPractice && ((schoolMenu == 2 && isFinalRecord) || (schoolMenu == 5 && isFinalRecord)) && !isCustomizeHomework"
          @refreshTextExam="refreshTextExam" @practiceBack="practiceBack" :showCourseOutline="false"
          :examType="'record'" :schoolMenu="schoolMenu"></answerSheet>
        <!-- 测验 -->
        <testExam v-if="menuValue == 3 && !showPractice" :courseDetail="courseDetail" @changeStep="changeStep"
          :key="refreshKey" ref="testExam">
        </testExam>
        <!-- 测验试题展示 -->
        <div class="test_paper_practice" v-if="menuValue == 3 && showPractice">
          <testPaper :examInfo="practiceInfo" :testTitle="testTitle" @practiceBack="practiceBack"
            @refreshTextExam="refreshTextExam"></testPaper>
        </div>
        <!-- 测验右部 -->
        <div v-if="menuValue == 3">
          <schoolRight :hideClass="true" :showCourseOutline="false" :courseId="courseId" :courseDetail="courseDetail"
            v-if="!showPractice">
          </schoolRight>
          <answerSheet v-else :showCourseOutline="false" :examType="'practice'" @refreshTextExam="refreshTextExam">
          </answerSheet>
        </div>
        <!-- 讨论组 -->
        <discussion v-if="menuValue == 4" :courseDetail="courseDetail"></discussion>
        <examine v-if="menuValue == 5" :courseDetail="courseDetail" @changeStep="changeStep" :key="refreshKey">
        </examine>
        <!-- 讨论组右部 -->
        <!-- <answerSheet v-if="menuValue == 5" :showCourseOutline="false"></answerSheet> -->
        <div v-if="menuValue == 5">
          <schoolRight :hideClass="true" :showCourseOutline="false" :courseId="courseId" :courseDetail="courseDetail"
            v-if="!showPractice">
          </schoolRight>
          <answerSheet v-else :showCourseOutline="false" :examType="'practice'" @refreshTextExam="refreshTextExam">
          </answerSheet>
        </div>
        <!-- 综合分析 -->
        <comprehensiveEvaluation :courseDetail="courseDetail" v-if="menuValue == 6" :showCourseOutline="false">
        </comprehensiveEvaluation>
        <!-- 综合分析右部 -->
        <schoolRight v-if="menuValue == 6 || menuValue == 4" :hideClass="true" :showCourseOutline="false"
          :courseId="courseId" :courseDetail="courseDetail"></schoolRight>
      </div>
    </div>
    <learningEvaluate ref="learningEvaluate"></learningEvaluate>
    <moe-right ref="moeRight"></moe-right>
  </moe-page>
</template>

<script>
import learningEvaluate from "@/components/popup/learningEvaluate.vue";
import leftMenu from "./components/leftMenu.vue";
import introduce from "./components/introduce.vue";
import introduceRight from "./components/introduceRight.vue";
import school from "./components/school.vue";
import schoolRight from "./components/schoolRight.vue";
import testExam from "./components/testExam.vue";
import discussion from "./components/discussion.vue";
import examine from "./components/examine.vue";
import comprehensiveEvaluation from "./components/comprehensiveEvaluation.vue";
import answerSheet from "@/components/exam/answerSheet.vue";
import testPaper from './components/testPaper.vue';
import filter from "@/mixins/filter";
import exerciseConsolidationVue from './components/exerciseConsolidation.vue';
import wrongQuestionAnalysis from './components/wrongQuestionAnalysis.vue';
import chapterChallenge from './components/chapterChallenge.vue';
// import wrongQuestionPaper from "./components/wrongQuestionPaper.vue";
import customeHomeworkRecord from "./components/customeHomeworkRecord.vue";
import customizeHomeworkSheet from "@/components/exam/customizeHomeworkSheet.vue";
import { mapState } from "vuex";
import assessmentClearance from './components/assessmentClearance.vue';
import recordTestPaper from './components/recordTestPaper.vue';
import backlog from "./components/backlog.vue";
export default {
  name: "GjkcH5Index",
  components: {
    leftMenu,
    introduce,
    introduceRight,
    school,
    schoolRight,
    testExam,
    discussion,
    comprehensiveEvaluation,
    answerSheet,
    learningEvaluate,
    testPaper, examine, exerciseConsolidationVue, chapterChallenge, wrongQuestionAnalysis, assessmentClearance,
    // wrongQuestionPaper, 
    recordTestPaper, customeHomeworkRecord, customizeHomeworkSheet, backlog
  },
  mixins: [filter],
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
      isEnterExamList: (state) => state.learning.isEnterExamList,
    }),
  },
  data() {
    return {
      courseInfo: {},
      menuValue: 7,
      courseId: "",
      courseDetail: {},
      courseChapterList: [],
      videoUrl: '',
      testStep: '',
      refreshKey: 0,
      showPractice: false,
      practiceInfo: {},  // 随堂练习试题
      schoolMenu: 1,  // 学堂展示控制
      testTitle: '',
      testType: 1,
      refreshRightey: 1, // 用于左侧切换菜单刷新右侧组件
      isFinalRecord: false, // 用于通关判断展示答题还是答题记录
      wrongTitle: '错题分析',  // 展示纠错标题
      courseSettingInfo: {},
      isCustomizeHomework: false,
      isWrongReubmit: false,  // 是否错题重做
      companionTeacherInfo: {}, // 伴学师详情
      backlogStep: '',
    };
  },
  provide() {
    return {
      updateShowPractice: this.updateShowPracticeValue,
      changeSchoolMenu: this.changeSchoolMenu,
      practiceBack: this.practiceBack,
      showWrongQuestion: this.showWrongQuestion,
      showCustomizeHomework: this.showCustomizeHomework
    }
  },
  mounted() {
    this.courseId = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).courseId;
    if (this.$Jump.getUrlParams(window.location.hash.split("?")[1]).menuValue) {
      this.menuValue = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).menuValue;
    }
    if (this.isEnterExamList) {
      this.menuValue = 7;
      this.backlogStep = 3;
      this.$store.commit("learning/setIsEnterExamList", false);
    }
    this.getCourseDetail();
    this.getSchemeByCourseId();
    this.getQuestionTypeList();
    this.setCourseInfo();
    this.getClassRomeInfo();
    setTimeout(() => {
      if (this.$Jump.getUrlParams(window.location.hash.split("?")[1]).menuValue) {
        this.menuValue = this.$Jump.getUrlParams(
          window.location.hash.split("?")[1]
        ).menuValue;
      }
    }, 500);
  },
  unmounted() {
    if (!this.$Tools.empty(this.selectLearningInfo)) {
      this.$store.commit("learning/setSelectLearningInfo", {});
      this.$store.commit("learning/setIsFreeLearning", false);
    }
  },

  methods: {
    // 课程班级详情
    getClassRomeInfo() {
      this.$Api.course.getClassRomeInfo({ courseId: this.courseId }).then(res => {
        if (!this.$Tools.empty(res.data.data)) {
          if (!this.$Tools.empty(res.data.data.accompanyingTeacherVoList)) {
            this.$refs.moeRight.getMenuList(res.data.data.accompanyingTeacherVoList[0].image);
            this.$refs.moeRight.companionTeacherQrcode = res.data.data.accompanyingTeacherVoList[0].image;
            this.companionTeacherInfo = res.data.data.accompanyingTeacherVoList[0]; // 伴学师详情
            console.log(this.companionTeacherInfo)
          }
        }
      }).catch(() => { })
    },
    // 课程设置信息
    setCourseInfo() {
      this.$Api.course
        .setCourseInfo(this.courseId)
        .then((res) => {
          this.courseSettingInfo = res.data.data;
          this.$refs.moeRight.getMenuList(this.courseSettingInfo.companionTeacherQrcode);
        })
        .catch(() => { });
    },
    // 获取课程学习进度（获取方案）
    getSchemeByCourseId() {
      this.$Api.course
        .getChapterProgress({ courseIds: this.courseId })
        .then((res) => {
          // 设置缓存
          this.$store.commit("learning/setCourseScheme", res.data.data[0]?.schemeId);
        })
        .catch(() => { });
    },
    // 改变课时内容
    changeSchoolMenu(value) {
      this.schoolMenu = value;
    },
    updateShowPracticeValue(value, paperId, sort, homeworkType) {
      this.isCustomizeHomework = false;
      this.isFinalRecord = false;
      if (sort != undefined) {
        this.$Api.exam.getChallengeInfo(paperId, sort).then(res => {
          this.practiceInfo = res.data.data;
          this.testTitle = res.data.data?.paperName;
          this.showPractice = value;
        }).catch(() => { })
      } else {
        if (homeworkType == 'homework') {
          // 获取课堂作业
          this.$Api.course.getPaperInfo(paperId).then(res => {
            this.practiceInfo = res.data.data;
            this.testTitle = res.data.data?.paperName;
            this.showPractice = value;
          }).catch(() => { })
        } else {
          // 获取课后作业
          this.$Api.exam.getAfterHomeworkPaperInfo(paperId).then(res => {
            this.practiceInfo = res.data.data;
            this.testTitle = res.data.data?.paperName;
            this.showPractice = value;
          }).catch(() => { })
        }

      }
    },
    // 展示错题
    showWrongQuestion(value, list, isClassics, isFinalRecord, title, isWrongReubmit) {
      this.isCustomizeHomework = false;
      if (isClassics) {
        this.practiceInfo = {
          paperType: 'wrongQuestion', // 用于区分错题还是试卷
          paperContext: list
        };
      } else {
        this.practiceInfo = list;
      }
      this.showPractice = value;
      this.isFinalRecord = isFinalRecord;
      this.wrongTitle = title;
      this.isWrongReubmit = isWrongReubmit;
    },
    // 展示自定义作业详情
    showCustomizeHomework(value, recordInfo, isFinalRecord) {
      this.showPractice = value;
      this.isFinalRecord = isFinalRecord;
      this.isCustomizeHomework = true;
      setTimeout(() => {
        this.$refs.customeHomeworkRecord.homeworkInfo = recordInfo;
        this.$refs.customizeHomeworkSheet.homeworkInfo = recordInfo;
        if (recordInfo.markScoreType == 2) {
          setTimeout(() => {
            this.$refs.customizeHomeworkSheet.handlerHomeworkInfo();
          }, 500)
        }
      }, 500)
    },
    practiceBack(flag, isHome, isChallenge, isFinalStep) {
      this.isCustomizeHomework = false;
      this.showPractice = flag;
      if (isHome) {
        this.schoolMenu = 2;
        this.$store.commit("learning/setIsHomeworkBack", true);
      }
      if (isChallenge) {
        this.schoolMenu = 3;
        this.$store.commit("learning/setIsChallengeBack", true);
      }
      if (isFinalStep) {
        this.schoolMenu = 5;
        // this.$store.commit("learning/setIsChallengeBack", true);
      }
    },
    // 获取题型列表
    getQuestionTypeList() {
      this.$Api.exam.getQuestionTypeList(this.courseId).then(res => {
        this.$store.commit('exam/setQuestionTypeList', res.data.data);
      }).catch(() => { })
    },
    changeStep(value) {
      this.testStep = value;
    },
    getCourseVideoUrl(url) {
      this.videoUrl = url;
    },
    getMenu(menuValue) {
      this.menuValue = menuValue;
      // 左侧tab切换时改变schoolMenu为默认值
      this.schoolMenu = 1;
      this.showPractice = false;
      this.refreshRightey += 1;
      if (menuValue == 3 || menuValue == 2) {
        this.$store.commit("exam/setTestExamInfo", {});
      }
    },
    // 课程详情
    getCourseDetail() {
      this.$Api.course
        .getCourseDetail(this.courseId)
        .then((res) => {
          this.courseDetail = res.data.data;
          // this.courseDetail.courseIntro = this.courseDetail.courseIntro.replace(
          //   /<img/g,
          //   '<img style="max-width:100%; height:auto;" '
          // );
        })
        .catch(() => {
        });
    },
    // 获取课程章节列表
    getCourseChapter() {
      this.$Api.course
        .getCourseChapter({ courseId: this.courseId })
        .then((res) => {
          let courseChapterList = res.data.data;
          this.courseChapterList = this.$Tree.handleTree(
            courseChapterList,
            "chapterId",
            "parentId"
          );
          // 统计时长
          this.courseChapterList = this.getAllChildren(this.courseChapterList);
        })
        .catch(() => {
        });
    },
    // 我的笔记
    goMyNote() {
      this.$Jump.href("/learningCenter", { selectMenu: 2 });
    },
    // 学习时长
    goStudyLongTime() { },
    // 评价
    goEvaluate() {
      this.$refs.learningEvaluate.learningEvaluateShow = true;
      this.$refs.learningEvaluate.evaluateInfo.courseId = this.courseId;
    },
    // 刷新测试组件
    refreshTextExam() {
      this.refreshKey += 1;
    },
    // 课堂作业返回列表（人工判分提交后返回）
    backList() {
      if (this.schoolMenu == 2) {
        this.$refs.testPaper.practiceBack();
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.top_blurb {
  width: 100%;
  height: 60px;
  border-top: 1px solid rgba(243, 243, 243, 1);

  .top_blurb_box {
    width: $pageMainWidth;
    height: 60px;

    .top_blurb_left {
      height: 46px;

      .video_img {
        width: 80px;
        height: 46px;
        border-radius: 5px;
      }

      .top_blurb_text {
        margin-left: 12px;

        .course_title {
          // font-weight: bold;
          color: #111111;
        }

        .course_organizationName {
          // font-size: 14px;
          color: #13d6aa;
        }
      }

      .course_type {
        margin-left: 12px;
        // width: 54px;
        height: 24px;
        background: linear-gradient(90deg, #00d5c2, #00d498);
        border-radius: 12px;
        line-height: 24px;
        text-align: center;
        font-size: 14px;
        color: #ffffff;
        padding: 0 10px;
      }
    }

    .top_blurb_right {
      .top_blurb_right_one {
        height: 46px;
        font-size: 14px;
        color: #666666;
        margin-right: 20px;

        .notes_icon {
          width: 22px;
          height: 22px;
        }
      }
    }
  }
}

.blurb_content {
  width: 100%;
  min-height: calc(100vh - $pageTopHeight - 60px);
  background: #f3f3f3;

  .content_box {
    width: $pageMainWidth;
    margin-top: 20px;
  }

  .test_paper_practice {
    width: 762px;
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 10px;
  }
}
</style>
